export function isIE() {
  return window.document.documentMode !== undefined;
}

export function isEdge() {
  return window.StyleMedia !== undefined;
}

function isMSLegacy() {
  return isIE() || isEdge();
}

export default isMSLegacy;
